export default __webpack_public_path__ + "static/media/SEVOB.30180846.png";